import React from 'react'
import ReactDOM from 'react-dom'
import AppDocs from 'app/AppDocs.jsx'

import 'app/assets/scss/index.scss'

const pkgPath = '/home/lapis/repos/gh/formiga'

const pkgJson = JSON.parse(`
  {
  "name": "formiga",
  "version": "0.1.8",
  "description": "The simplest -yet effective- form validator for React",
  "keywords": [
    "js",
    "react",
    "form",
    "validation"
  ],
  "author": "Donato Lorenzo <donato@afialapis.com>",
  "contributors": [
    "Donato Lorenzo <donato@afialapis.com>"
  ],
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/afialapis/formiga.git"
  },
  "bugs": {
    "url": "https://github.com/afialapis/formiga/issues"
  },
  "homepage": "https://formiga.afialapis.com/",
  "files": [
    "lib",
    "dist",
    "logo",
    "docaine.json",
    "formiga.png"
  ],
  "type": "module",
  "main": "./lib/index.cjs",
  "cjs": "./dist/formiga.cjs",
  "browser": "./dist/formiga.umd.js",
  "module": "./dist/formiga.mjs",
  "exports": {
    "import": "./dist/formiga.mjs",
    "default": "./lib/index.cjs",
    "require": "./dist/formiga.cjs"
  },
  "scripts": {
    "clean-demo": "rm -rf demo/dist",
    "clean-lib": "rm -rf lib && mkdir lib",
    "clean-dist": "rm -rf dist && mkdir dist",
    "clean-site": "rm -rf arredemo",
    "clean-all": "npm run --silent clean-demo && npm run --silent clean-lib && npm run --silent clean-dist && npm run --silent clean-site",
    "lint": "npx xeira lint",
    "test": "npx xeira test --files=./test/before.mjs,./test/units/*.cjs",
    "lib": "npm run --silent clean-lib && npx xeira transpile",
    "dist": "npm run --silent clean-dist && npx xeira bundle",
    "site": "npm run --silent clean-site && npx xeira site",
    "prepare": "npm run --silent clean-demo && npm run --silent lint && npm run --silent test && npm run --silent lib && npm run --silent dist && npm run --silent site",
    "demo": "npm run --silent clean-demo && npx xeira demo --port=8001",
    "reset": "npm run --silent clean-all && rm -fr node_modules package-lock.json && npm i"
  },
  "devDependencies": {
    "xeira": "^0.3.3"
  },
  "peerDependencies": {
    "react": ">=16.13.1"
  },
  "eslintConfig": {
    "extends": [
      "./node_modules/xeira/configs/eslint.react.cjs"
    ]
  }
}
`)

const arreConfig = JSON.parse(`
{
  "theme": "default",
  "company": "Afialapis",
  "url": "formiga.afialapis.com",
  "doc_versions": [],
  "md": {
    "md_keep_summary_content": false,
    "md_strip_details_tag": true
  },
  "demo_entry": "demo/src/Demo.js",
  "has_demo": true,
  "logo": {
    "ok": true,
    "src": "logo/formiga_200.png",
    "dest": "logo.png"
  },
  "favicon": {
    "main": {
      "ok": true,
      "src": "logo/favicon/formiga.png",
      "dest": "favicon.png"
    },
    "ico": {
      "ok": true,
      "src": "logo/favicon/formiga.ico",
      "dest": "favicon.ico"
    },
    "apple": {
      "ok": true,
      "src": "logo/favicon/formiga_apple.png",
      "dest": "favicon_apple.png"
    }
  }
}
`)

const md_0_1_8 = decodeURIComponent(escape(window.atob(`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`)));


const readmes = {
"0.1.8": md_0_1_8,
}



ReactDOM.render(
  <AppDocs 
    pkgPath = {pkgPath}
    pkgJson = {pkgJson}
    arreConfig = {arreConfig}
    readmes = {readmes}      
  />,
  document.getElementById('arredemo-app'))

/*

// React 18

ReactDOM.createRoot(document.getElementById("arredemo-app")).render(
  <React.StrictMode>
    <AppDocs 
      pkgPath = {pkgPath}
      pkgJson = {pkgJson}
      arreConfig = {arreConfig}
      readmes = {readmes}      
    />
  </React.StrictMode>
);
*/

